/**
 * Saves and Array to local storage
 * @ignore
 * @param {string} key - Local storage key
 * @param {array} data - Array of unknown
 *
 * @return {void}
 */
export default function saveArrayToStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}
